module.exports = __webpack_public_path__ + "img/contact-sales-bg-right.674be9ee.svg";